import sha256 from 'crypto-js/sha256';
import sessionReader from '../store/readHelpers/SessionReader';

const securityService = {
    verifyInvigilatorPassword(passwordInput) {
        const passwordInputHash = sha256(passwordInput).toString();
        const invigilatorPasswordHash = sessionReader.getInvigilatorPassword();

        return passwordInputHash === invigilatorPasswordHash;
    },
    verifyDayCode(passwordInput, dayCode) {
        const passwordInputHash = sha256(passwordInput).toString();
        return passwordInputHash === dayCode;
    },
};

export default securityService;
